/*
 *
 * Copyright 2018 Odysseus Data Services, inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 *  limitations under the License.
 *
 * Company: Odysseus Data Services, Inc.
 * Product Owner/Architecture: Gregory Klebanov
 * Authors: Alexandr Saltykov, Pavel Grafkin, Vitaly Koulakov, Anton Gackovka
 * Created: March 3, 2017
 *
 */

import { combineReducers } from 'redux';
import core from './core';
import services from '../apiServices';

export default combineReducers({
	core,
	logout: services.auth_logout.reducer,
	principal: services.auth_principal.reducer,
	professionalTypes: services.auth_professionalTypes.reducer,
	countries: services.auth_countries.reducer,
	provinces: services.auth_provinces.reducer,
	remindPasswors: services.remind_password.reducer,
});
